import "../../../Styles/main.scss"
import ArticalCard from "../ArticleCard/ArticleCard"

interface Props {
    children: React.JSX.Element[] | React.JSX.Element
    leftPanelFirstComponent?: React.JSX.Element[] | React.JSX.Element
    leftPanelSecondComponent?: React.JSX.Element[] | React.JSX.Element
    leftPanelThirdComponent?: React.JSX.Element[] | React.JSX.Element | null
    leftPanelForthComponent?: React.JSX.Element[] | React.JSX.Element | null
    leftPanelFifthComponent?: React.JSX.Element[] | React.JSX.Element | null
    RightPanelFirstComponent?: React.JSX.Element[] | React.JSX.Element | null
    RightPanelSecondComponent?: React.JSX.Element[] | React.JSX.Element
    RightPanelThirdComponent?: React.JSX.Element[] | React.JSX.Element
    RightPanelForthComponent?: React.JSX.Element[] | React.JSX.Element
    RightPanelFifthComponent?: React.JSX.Element[] | React.JSX.Element
    RightPanelSixthComponent?: React.JSX.Element[] | React.JSX.Element | null
    overflowModifier?: boolean
    noPadding?: boolean
    isDashboad?: boolean
}
function MainLayout({
    children,
    leftPanelFirstComponent,
    leftPanelSecondComponent,
    leftPanelThirdComponent,
    leftPanelForthComponent,
    leftPanelFifthComponent,
    RightPanelFirstComponent,
    RightPanelSecondComponent,
    RightPanelThirdComponent,
    RightPanelForthComponent,
    RightPanelFifthComponent,
    RightPanelSixthComponent,
    overflowModifier,
    noPadding,
    isDashboad,
}: Props) {
    return (
        <div className="main-layout">
            <div className={`main-layout__container ${isDashboad ? "main-layout__container--dashboard" : ""}`}>
                <div className="main-left-panel">
                    <div className="main-left-panel__container">
                        {leftPanelFirstComponent}
                        {leftPanelSecondComponent}
                        {leftPanelThirdComponent}
                        <p className="main-left-panel__text">{leftPanelForthComponent}</p>
                        {leftPanelFifthComponent}
                    </div>
                </div>
                <div className={`main-middle-panel ${noPadding && "main-middle-panel--no-padding"} ${isDashboad ? "main-middle-panel--dashboard" : ""}`}>
                    <div className="main-middle-panel__child-container"> {children} </div>
                </div>
                <div className="main-right-panel">
                    <div
                        className={`main-right-panel__container ${
                            overflowModifier ? "main-right-panel__container--overflow" : "main-right-panel__container--size"
                        }`}
                    >
                        {RightPanelFirstComponent}
                        {isDashboad && <ArticalCard />}
                        <p className="main-right-panel__text"> {RightPanelSecondComponent} </p>
                        {RightPanelThirdComponent}
                        {RightPanelForthComponent}
                        {RightPanelFifthComponent}
                        <p className="main-right-panel__text"> {RightPanelSixthComponent}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainLayout
